module.exports = __webpack_public_path__ + "img/car-orange.51c42951.svg";